"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsMappers = void 0;
var WFacebookLike = __importStar(require("./components/WFacebookLike/WFacebookLike"));
var FacebookShare = __importStar(require("./components/FacebookShare/FacebookShare"));
var TextAreaInput = __importStar(require("./components/TextAreaInput/TextAreaInput"));
var PinterestPinIt = __importStar(require("./components/PinterestPinIt/PinterestPinIt"));
var PayPalButton = __importStar(require("./components/PayPalButton/PayPalButton"));
var YouTubeSubscribeButton = __importStar(require("./components/YouTubeSubscribeButton/YouTubeSubscribeButton"));
var VerticalAnchorsMenu = __importStar(require("./components/VerticalAnchorsMenu/VerticalAnchorsMenu"));
var WTwitterTweet = __importStar(require("./components/WTwitter/WTwitterTweet/WTwitterTweet"));
var WTwitterFollow = __importStar(require("./components/WTwitter/WTwitterFollow/WTwitterFollow"));
var SpotifyPlayer = __importStar(require("./components/SpotifyPlayer/SpotifyPlayer"));
var TextInput = __importStar(require("./components/TextInput/TextInput"));
var VideoPlayer = __importStar(require("./components/VideoPlayer/VideoPlayer"));
var Video = __importStar(require("./components/VideoLegacy/VideoLegacy"));
var VKShareButton = __importStar(require("./components/VKShareButton/VKShareButton"));
var Masonry = __importStar(require("./components/Masonry/Masonry"));
var StripSlideshow = __importStar(require("./components/StripSlideshow/StripSlideshow"));
var MusicPlayer = __importStar(require("./components/MusicPlayer/MusicPlayer"));
var StripShowcase = __importStar(require("./components/StripShowcase/StripShowcase"));
var TPA3DGallery = __importStar(require("./components/Tpa3DGallery/Tpa3DGallery"));
var TPA3DCarousel = __importStar(require("./components/Carousel/Carousel"));
var Freestyle = __importStar(require("./components/Freestyle/Freestyle"));
var Honeycomb = __importStar(require("./components/Honeycomb/Honeycomb"));
var Thumbnails = __importStar(require("./components/Thumbnails/Thumbnails"));
var Accordion = __importStar(require("./components/Accordion/Accordion"));
var Impress = __importStar(require("./components/Impress/Impress"));
var Collage = __importStar(require("./components/Collage/Collage"));
var DisqusComments = __importStar(require("./components/DisqusComments/DisqusComments"));
var SpotifyFollow = __importStar(require("./components/SpotifyFollow/SpotifyFollow"));
var PinItPinWidget = __importStar(require("./components/PinItPinWidget/PinItPinWidget"));
var SoundCloudWidget = __importStar(require("./components/SoundCloudWidget/SoundCloudWidget"));
var FlickrBadgeWidget = __importStar(require("./components/FlickrBadgeWidget/FlickrBadgeWidget"));
var Grid = __importStar(require("./components/Grid/Grid"));
var SlideShowContainer = __importStar(require("./components/SlideShowContainer/SlideShowContainer"));
var Pagination = __importStar(require("./components/Pagination/Pagination"));
var SlideShowSlide = __importStar(require("./components/SlideShowSlide/SlideShowSlide"));
var RatingsInput = __importStar(require("./components/RatingsInput/RatingsInput"));
var SelectionTagsList = __importStar(require("./components/SelectionTagsList/SelectionTagsList"));
var ToggleSwitch = __importStar(require("./components/ToggleSwitch/ToggleSwitch"));
var LineShareButton = __importStar(require("./components/LineShareButton/LineShareButton"));
var Captcha = __importStar(require("./components/Captcha/Captcha"));
var CustomElementComponent = __importStar(require("./components/CustomElementComponent/CustomElementComponent"));
var RichTextBox = __importStar(require("./components/RichTextBox/RichTextBox"));
var RatingsDisplay = __importStar(require("./components/RatingsDisplay/RatingsDisplay"));
var SlideShowGallery = __importStar(require("./components/SlideShowGallery/SlideShowGallery"));
var TimePicker = __importStar(require("./components/TimePicker/TimePicker"));
var SingleAudioPlayer = __importStar(require("./components/SingleAudioPlayer/SingleAudioPlayer"));
var DatePicker = __importStar(require("./components/DatePicker/DatePicker"));
var Slider = __importStar(require("./components/Slider/Slider"));
var FlashComponent = __importStar(require("./components/FlashComponent/FlashComponent"));
var SignatureInput = __importStar(require("./components/SignatureInput/SignatureInput"));
var MatrixGallery = __importStar(require("./components/MatrixGallery/MatrixGallery"));
var PaginatedGridGallery = __importStar(require("./components/PaginatedGridGallery/PaginatedGridGallery"));
var StateBox = __importStar(require("./components/StateBox/StateBox"));
var LoginButton = __importStar(require("./components/LoginButton/LoginButton"));
var AddressInput = __importStar(require("./components/AddressInput/AddressInput"));
var ProgressBar = __importStar(require("./components/ProgressBar/ProgressBar"));
var SliderGallery = __importStar(require("./components/SliderGallery/SliderGallery"));
var SeoTpaGallery = __importStar(require("./components/SeoTpaGallery/SeoTpaGallery"));
var SocialAuth = __importStar(require("./components/SocialAuth/SocialAuth"));
var StylableHorizontalMenu = __importStar(require("./components/StylableHorizontalMenu/StylableHorizontalMenu"));
var Breadcrumbs = __importStar(require("./components/Breadcrumbs/Breadcrumbs"));
var AudioPlayer = __importStar(require("./components/AudioPlayer/AudioPlayer"));
exports.componentsMappers = {
    TextInput: TextInput,
    WFacebookLike: WFacebookLike,
    FacebookShare: FacebookShare,
    TextAreaInput: TextAreaInput,
    PinterestPinIt: PinterestPinIt,
    PayPalButton: PayPalButton,
    YouTubeSubscribeButton: YouTubeSubscribeButton,
    VideoPlayer: VideoPlayer,
    Video: Video,
    VerticalAnchorsMenu: VerticalAnchorsMenu,
    WTwitterTweet: WTwitterTweet,
    WTwitterFollow: WTwitterFollow,
    SpotifyPlayer: SpotifyPlayer,
    VKShareButton: VKShareButton,
    MusicPlayer: MusicPlayer,
    Masonry: Masonry,
    StripSlideshow: StripSlideshow,
    DatePicker: DatePicker,
    StripShowcase: StripShowcase,
    TPA3DGallery: TPA3DGallery,
    TPA3DCarousel: TPA3DCarousel,
    Freestyle: Freestyle,
    Honeycomb: Honeycomb,
    Thumbnails: Thumbnails,
    Accordion: Accordion,
    Impress: Impress,
    Collage: Collage,
    DisqusComments: DisqusComments,
    SpotifyFollow: SpotifyFollow,
    PinItPinWidget: PinItPinWidget,
    SoundCloudWidget: SoundCloudWidget,
    SlideShowContainer: SlideShowContainer,
    SlideShowSlide: SlideShowSlide,
    Pagination: Pagination,
    FlickrBadgeWidget: FlickrBadgeWidget,
    Grid: Grid,
    RatingsInput: RatingsInput,
    SelectionTagsList: SelectionTagsList,
    ToggleSwitch: ToggleSwitch,
    LineShareButton: LineShareButton,
    Captcha: Captcha,
    CustomElementComponent: CustomElementComponent,
    RichTextBox: RichTextBox,
    RatingsDisplay: RatingsDisplay,
    SlideShowGallery: SlideShowGallery,
    TimePicker: TimePicker,
    AudioPlayer: AudioPlayer,
    SingleAudioPlayer: SingleAudioPlayer,
    Slider: Slider,
    FlashComponent: FlashComponent,
    SignatureInput: SignatureInput,
    MatrixGallery: MatrixGallery,
    PaginatedGridGallery: PaginatedGridGallery,
    StateBox: StateBox,
    LoginButton: LoginButton,
    AddressInput: AddressInput,
    ProgressBar: ProgressBar,
    SliderGallery: SliderGallery,
    SeoTpaGallery: SeoTpaGallery,
    SocialAuth: SocialAuth,
    StylableHorizontalMenu: StylableHorizontalMenu,
    Breadcrumbs: Breadcrumbs,
};
//# sourceMappingURL=componentExtensions.js.map